import React from 'react';
import { withRouteData } from 'react-static';
import Loans from '../layout/Loans';

export default withRouteData(({ getLoans }) => (
  <Loans getLoans={getLoans} />
));
